import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { BASE_URL, OG_IMAGE } from '../utils/seo';
import { enterUp } from '../utils/animations';
import { PolicyContent } from '../components/privacy/PolicyContent';

export default function PrivacyPolicy() {
    return (
        <div data-testid="privacy-policy-page">
            <Helmet>
                <title>Privacy Policy - White Glove Hiring</title>
                <meta name="description" content="Privacy policy for White Glove Hiring. How we collect, use, and protect your personal information." />
                <meta property="og:title" content="Privacy Policy - White Glove Hiring" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`${BASE_URL}/privacy-policy`} />
                <meta property="og:image" content={OG_IMAGE} />
                <link rel="canonical" href={`${BASE_URL}/privacy-policy`} />
            </Helmet>

            <section className="bg-navy-900 hero-pattern pt-36 pb-20">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <motion.div {...enterUp}>
                        <p className="text-gold-400 text-xs font-bold tracking-[0.3em] uppercase font-inter mb-4">Legal</p>
                        <h1 className="font-montserrat font-black text-5xl md:text-6xl text-white tracking-tight leading-tight">
                            Privacy Policy
                        </h1>
                        <p className="text-gray-300 text-lg mt-5">Last updated: September 24, 2026</p>
                    </motion.div>
                </div>
            </section>

            <PolicyContent />
        </div>
    );
}
